import React from 'react'
import LoginDialog from '../login'
import { setUserInfo, setUserName } from '@utils/session'

const LoginSessionHoc = (props: any) => {
  const afterLogin = (data?: any, error?: any) => {
    if (data) {
      setUserInfo(data.userId, data.sessionKey)
      setUserName(data.name)
    }
    if (error) {
      console.error(error)
    }
  }

  return <LoginDialog afterLogin={afterLogin} {...props} />
}

export default LoginSessionHoc
